import {
  HttpErrors,
  HttpErrorType,
  SlotBookingConflictApiResponseError,
} from '@omecare/utils';

// Surcharge pour agenda_slot_booking_conflict
export function getErrorPayload({
  error,
  type,
}: {
  error: HttpErrors;
  type: 'agenda_slot_booking_conflict';
}): SlotBookingConflictApiResponseError | null;

// Version générique pour les autres types
export function getErrorPayload<T = unknown>({
  error,
  type,
}: {
  error: HttpErrors;
  type: HttpErrorType;
}): T | null;

// Implémentation
export function getErrorPayload<T = unknown>({
  error,
  type,
}: {
  error: HttpErrors;
  type: HttpErrorType;
}): T | SlotBookingConflictApiResponseError | null {
  if (!error.data) {
    throw new Error('Error data should be defined');
  }

  if (error.data.error !== type) {
    return null;
  }

  if (type === 'agenda_slot_booking_conflict') {
    return error.data as SlotBookingConflictApiResponseError;
  }

  return error.data as T;
}
